import { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { wacToken } from "@/libraries/design/foundations/index.ts";

export const Row = (props: HTMLAttributes<HTMLTableRowElement>) => {
    return <tr {...props} css={rowCss} />;
};

export interface RowHeaderCellProps
    extends HTMLAttributes<HTMLTableCellElement> {
    id?: string;
}

export const RowHeaderCell = (props: RowHeaderCellProps) => {
    const { children, ...thProps } = props;
    return (
        <th
            {...thProps}
            scope="row"
            css={[rowHeaderCellCss, cellCss]}
            style={{
                fontWeight: "normal",
                ...((thProps.style as object) ?? {})
            }}
        >
            <span css={rowHeaderCellSpanCss}>{children}</span>
        </th>
    );
};

export interface RowCellProps extends HTMLAttributes<HTMLTableCellElement> {
    columnTitle: string;
    headers?: string;
}
export const RowCell = (props: RowCellProps) => {
    const { children = null, columnTitle, headers, ...tdProps } = props;
    return (
        <td {...tdProps} css={cellCss} headers={headers}>
            <span css={cellColumnTitleCss}>{columnTitle}</span>
            {children}
        </td>
    );
};

const rowCss = css({
    "margin": "16px 0",
    "backgroundColor": wacToken("color.neutral.light0"),
    "transition": "background-color .5s",
    "padding": 0,
    "textAlign": "center",
    ":last-of-type": {
        marginBlockEnd: "0"
    },
    "&:hover": {
        backgroundColor: wacToken("color.neutral.light100")
    },
    [media.below.sm]: {
        border: `solid 1px ${wacToken("color.neutral.light400")}`,
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column"
    }
});

const rowHeaderCellCss = css({
    textAlign: "start",
    [media.below.sm]: {
        borderStartStartRadius: "20px",
        borderStartEndRadius: "20px",
        background: wacToken("color.neutral.light200"),
        padding: "14px"
    }
});

const rowHeaderCellSpanCss = css({
    width: "100%",
    overflowX: "hidden"
});

const cellCss = css({
    "verticalAlign": "top",
    "justifyContent": "space-between",
    "alignItems": "center",
    "fontWeight": 400,
    "textAlign": "left",
    "color": wacToken("color.primary.black"),
    [media.below.sm]: {
        display: "flex",
        padding: "12px 14px"
    },
    "display": "table-cell",
    "padding": "14px",
    "borderInlineEnd": `1px solid ${wacToken("color.neutral.light400")}`,
    ":last-of-type": {
        borderInlineEnd: "none"
    }
});

const cellColumnTitleCss = css({
    [media.above.sm]: {
        display: "none"
    }
});
